class MHeader extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      headers: ["header"],
      logos: [".m-logo"],
      topbar: ".m-topbar",
      headerWrapper: ".m-header__wrapper",
      topbarClose: ".m-topbar__close",
    };
    this.domNodes = queryDomNodes(this.selectors, this);
    this.innerWidth = window.innerWidth;
    this.headerOffsetTop = this.domNodes.headerWrapper.offsetTop;
    this.headerHeight = this.domNodes.headerWrapper.offsetHeight;
    this.stickyHeader = this.dataset.sticky;

    this.classes = {
      scrollUp: "scroll-up",
      scrollDown: "scroll-down",
      stuck: "stuck",
      always: "header-sticky-always",
      headerScrollUp: "header-scroll-up",
      headerScrollDown: "header-scroll-down",
    };
    this.init();
  }

  init() {
    this.transparentHeader =
      this.domNodes && this.domNodes.headers[0] && this.domNodes.headers[0].dataset.transparent === "true";
    this.initAddon();
    this.handleSticky();
    document.addEventListener("matchMobile", () => this.handleSticky());
    document.addEventListener("unmatchMobile", () => this.handleSticky());
    this.siteNav = new SiteNav(this);
    window.__sfHeader = this;
    window.addEventListener("resize", () => {
      this.innerWidth = window.innerWidth;
    });
  }

  initAddon() {
    this.megamenu = new Megamenu(this);
    if (Shopify.designMode) {
      MinimogTheme = MinimogTheme || {};
      MinimogTheme && MinimogTheme.Wishlist && MinimogTheme.Wishlist.updateWishlistCount();
    }
  }
  handleSticky() {
    let extraSpace = 20;
    const sectionGroups = document.querySelectorAll(".shopify-section-group-header-group");
    sectionGroups.forEach((section) => {
      if (!section.classList.contains("m-section-header") && !section.classList.contains("m-section-scaling-logo")) {
        extraSpace += section.offsetHeight;
      }
    });
    const topBar = document.querySelector(".m-topbar");
    if (topBar) extraSpace += topBar.offsetHeight;

    let lastScroll = 0;
    window.addEventListener("scroll", () => {
      const currentScroll = window.scrollY;
      if (currentScroll <= extraSpace) {
        this.classList.remove(this.classes.scrollUp, this.classes.stuck, this.classes.always);
        document.body.classList.remove(this.classes.headerScrollUp, this.classes.headerScrollDown);
        return;
      }

      if (this.stickyHeader === "on_scroll_up") {
        this.classList.add(this.classes.stuck);
      } else if (this.stickyHeader === "always") {
        this.classList.add(this.classes.always);
      }

      if (
        currentScroll > this.headerHeight + extraSpace &&
        currentScroll > lastScroll &&
        !this.classList.contains(this.classes.scrollDown)
      ) {
        this.classList.remove(this.classes.scrollUp);
        document.body.classList.remove(this.classes.headerScrollUp);
        this.classList.add(this.classes.scrollDown);
        document.body.classList.add(this.classes.headerScrollDown);
      } else if (currentScroll < lastScroll && this.classList.contains(this.classes.scrollDown)) {
        this.classList.remove(this.classes.scrollDown);
        document.body.classList.remove(this.classes.headerScrollDown);
        this.classList.add(this.classes.scrollUp);
        document.body.classList.add(this.classes.headerScrollUp);
      }
      lastScroll = currentScroll;
    });
  }
}
customElements.define("m-header", MHeader);
/* ===== FORCE LOGO CENTER ON MOBILE (Minimog) ===== */
(function () {
  function setImportant(el, prop, value) {
    if (!el) return;
    el.style.setProperty(prop, value, 'important');
  }

  function findLogo(root) {
    return (
      root.querySelector('.m-header__logo') ||
      root.querySelector('.m-header__branding') ||
      root.querySelector('.m-header__middle') ||
      root.querySelector('[class*="header__logo"]') ||
      root.querySelector('a[href="/"]') ||
      root.querySelector('a[href="/"] img')?.closest('a')
    );
  }

  function centerLogo() {
    const isMobile = window.matchMedia('(max-width: 768px)').matches;
    const header = document.querySelector('header');
    if (!header) return;

    const wrap =
      header.querySelector('.m-header__inner') ||
      header.querySelector('.m-header__container') ||
      header.querySelector('.m-header') ||
      header;

    const logo = findLogo(header);
    if (!logo) return;

    if (!isMobile) {
      // reset on desktop
      logo.style.removeProperty('position');
      logo.style.removeProperty('left');
      logo.style.removeProperty('transform');
      logo.style.removeProperty('top');
      wrap.style.removeProperty('position');
      return;
    }

    // make wrapper relative
    setImportant(wrap, 'position', 'relative');

    // absolute center logo
    setImportant(logo, 'position', 'absolute');
    setImportant(logo, 'left', '50%');
    setImportant(logo, 'transform', 'translateX(-50%)');
    setImportant(logo, 'top', '50%');
    setImportant(logo, 'translate', '0 -50%'); // modern browsers
    setImportant(logo, 'z-index', '999');
    setImportant(logo, 'margin', '0');
    setImportant(logo, 'padding', '0');
    setImportant(logo, 'white-space', 'nowrap');
  }

  // run
  document.addEventListener('DOMContentLoaded', centerLogo);
  window.addEventListener('load', centerLogo);
  window.addEventListener('resize', centerLogo);
})();